import { queryOptions } from "@tanstack/react-query";
import type { RoleCatalogEntry, RolesResponse } from "@/app/roles/types";
import { getCoordinatorApi } from "@/lib/api";
import { rolesKeys } from "./query-keys";

/** Role catalog rarely changes; cache it for a minute. */
const ROLES_STALE_TIME_MS = 60_000;

const fetchRoles = async (
  organizationId: string
): Promise<RoleCatalogEntry[]> => {
  const client = getCoordinatorApi({ organizationId });
  const { data } = await client.get<RolesResponse>("/authz/roles");
  return data.data.roles;
};

export const rolesQueryOptions = (organizationId: string) =>
  queryOptions<RoleCatalogEntry[]>({
    queryKey: rolesKeys.list(organizationId),
    staleTime: ROLES_STALE_TIME_MS,
    queryFn: () => fetchRoles(organizationId),
  });
